import React, { useState, useEffect } from 'react';

import { 
    Typography, 
    Slider, 
    Accordion, 
    AccordionSummary, 
    AccordionDetails,
    Box,
    useMediaQuery,
} from '@mui/material';

import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from 'react-redux';
import { uploadTraitStrengthMapping } from '../../redux/slices/onboarding/onboardingThunk';
import { setPreviousAnswers, setQuestionnaire } from '../../redux/slices/onboarding/onboardingSlice';

const SliderQuestion = ({qInd, pInd, answer, format }) => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const onMobile = !useMediaQuery('(min-width:600px)');

    const { questionnaire, previousAnswers, uploadingTraitStrengths } = useSelector(state => state.onboarding);

    const expandingMode = format === "EXPANDING_SLIDER";

    const [isFocused, setIsFocused] = useState("");
    const [defaultValue, setDefaultValue] = useState(answer.selected);

    useEffect(() => {
        setDefaultValue(answer.selected);
    }, [answer.selected])
    
    const valueLabelFormat = (defaultValue) => {
        const blocks = answer.render;
        return blocks[defaultValue];
    }

    const handleSliderChange = async (e, value) => {
        e.preventDefault();

        const tempPreviousAnswers = JSON.parse(JSON.stringify(previousAnswers));
        const tempQuestionnaire = JSON.parse(JSON.stringify(questionnaire));

        tempPreviousAnswers[answer.id] = value;
        dispatch(setPreviousAnswers(tempPreviousAnswers));

        tempQuestionnaire[pInd].SurveyQuestions[qInd].AnswerChoices.find((tempAnswer) => tempAnswer.id === answer.id).selected = value;
        dispatch(setQuestionnaire(tempQuestionnaire));
        console.log(tempPreviousAnswers)
        console.log(tempQuestionnaire)
        console.log(value)
        dispatch(uploadTraitStrengthMapping({ previousAnswers: tempPreviousAnswers, questionnaire: tempQuestionnaire, pageIndex: pInd }));
    }

    const handleAccordionChange = async (event, expanded, value) => {
        if (!expanded) value = 0
            await handleSliderChange(event, value);
    }

    const handleFocus = (e, id) => {
        e.preventDefault();
        setIsFocused(id);
      };
    
      const handleBlur = () => {
        setIsFocused("");
      };

    const getStep = () => {
        if (!(answer?.render && typeof answer.render === 'object')) return 0.25;
        if(Object.keys(answer.render).length === 3) return 0.5;
        else return 0.25;
    }


    const TraitSlider = (
        <Slider
            aria-label="Always visible"
            className="answer-card-slider"
            key={answer.id}
            defaultValue={answer.selected}
            step={getStep()}
            min={0}
            max={1}
            valueLabelDisplay={!expandingMode || isFocused === answer.id ? "on" : "off"}
            valueLabelFormat={valueLabelFormat}
            onFocus={e => handleFocus(e, answer.id)}
            onBlur={handleBlur}
            onChange={async (e) => await handleSliderChange(e, e.target.value) }
            sx={{
                marginTop: "2.5rem",
                color: "white",
                '& .MuiSlider-valueLabel': {
                    position: "fixed !important",
                    zIndex: "1000 !important",
                },
            }}
        />
    )

    return (
        <Box className='accordion-choices'
            sx={{
                display: "flex",
                height: "100%",
                width: '40vw',
                minWidth: "18rem",
                maxWidth: "25rem",
                flexWrap: "wrap",
                flexDirection: "row",
                alignItems: "center",
                gap: "20px",
                justifyContent: "center",
            }}
        >
            {
                !expandingMode ?
                    // sliders only
                    <Accordion
                        onChange={async (event, expanded) => await handleAccordionChange(event, expanded, defaultValue)}
                        defaultExpanded={defaultValue > 0}
                        disableGutters
                        sx={{
                            color: "white",
                            backgroundColor: theme.palette.caralystRed.main,
                            borderRadius: "0.25rem",
                            width: "100%",
                            overflow: "visible",
                        }}
                    >
                        <AccordionDetails>
                            {TraitSlider}
                        </AccordionDetails>
                    </Accordion>
                :
                    <Accordion
                        onChange={async (event, expanded) => await handleAccordionChange(event, expanded, defaultValue)}
                        defaultExpanded={defaultValue > 0}
                        disableGutters
                        disabled={uploadingTraitStrengths}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            color: "white",
                            backgroundColor: theme.palette.caralystRed.main,
                            width: "100%",
                            minHeight: "4rem",
                            filter: "brightness(75%)",
                            borderRadius: "0.25rem",
                            transition: "all 0.1s ease-in-out",
                            zIndex: answer.id === isFocused ? "1000" : "0",
                            '&.Mui-expanded': {
                                maxHeight: !onMobile ? "10rem" : "15rem",
                                backgroundColor: theme.palette.caralystRed.main,
                                filter: "brightness(100%)",
                            }
                        }}
                    >
                        <AccordionSummary aria-controls="panel1a-content" key={`panel${pInd}`}>
                            <Typography 
                                className='answer-card-title' 
                                color="white" 
                                fontWeight={500}
                                fontSize="1.25rem"
                            >
                                {"Former answer for patient"}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{marginTop: "-1rem", marginBottom: "-0.5rem"}}>
                            <Typography variant="h7">{"How important is this to your care?"}</Typography>
                            {TraitSlider}
                        </AccordionDetails>
                    </Accordion>
            }
        </Box>)
}

export default SliderQuestion;